const bendPointA = 1226
const bendPointB = 7391
// these two bendpoints change annually
// last updated May 2025
// found here: https://www.ssa.gov/oact/cola/bendpoints.html

export default (annualIncome) => {
  const aime = annualIncome / 12
  // this is our improvised AIME
  // it doesn't take into account inflation or any raises
  // uses a simple gross annual income, divided by 12 for monthly income

  // Multiply bendPointA by 90%.
  const a = aime >= bendPointA ? bendPointA * 0.9 : aime * 0.9

  // Multiply any difference between bendPointB and bendPointA by 32%
  const b = aime > bendPointB ? (bendPointB - bendPointA) * 0.32 : aime > bendPointA ? (aime - bendPointA) * 0.32 : 0

  // Multiply the amount over bendPointB by 15%.
  const c = aime > bendPointB ? (aime - bendPointB) * 0.15 : 0

  return a + b + c
}
